import ClientLanguage from "../enums/ClientLanguage";

export const LANG_STORAGE_KEY = "app.portal.lang";

export function getLanguage(): string {
  const lang = localStorage.getItem(LANG_STORAGE_KEY);
  return lang ?? ClientLanguage.EN.toString();
}

export function setLanguage(newLanguage: string): void {
  localStorage.setItem(LANG_STORAGE_KEY, newLanguage);
}
